export const MACHINES = {
  reformer: { label: "Max Reformer", sub: "Klasszikus stúdió alapgép" },
  feltornyos: { label: "Max Reformer Féltornyos", sub: "Teljes stúdió sokoldalúság" },
};

export const DELIVERY = {
  d48: { label: "48 nap", sub: "Expressz szállítás" },
  d96: { label: "96 nap", sub: "Standard szállítás" },
};

export const PAYMENTS = {
  cash: { label: "Egy összegben", sub: "" },
  lease_12: { label: "12 hónap", sub: "Részletfizetés" },
  lease_24: { label: "24 hónap", sub: "Részletfizetés" },
  lease_36: { label: "36 hónap", sub: "Részletfizetés" },
};

export const LEASE_MONTHS = { lease_12: 12, lease_24: 24, lease_36: 36 };

// Compact editable form (mirrors backend DEFAULT_PRICING_INPUT) – used until /api/pricing responds.
export const DEFAULT_PRICING_INPUT = {
  reformer: {
    price: 960000, express_fee: 30000,
    lease_12: { down: 395000, monthly: 72500 },
    lease_24: { down: 395000, monthly: 46900 },
    lease_36: { down: 395000, monthly: 38200 },
  },
  feltornyos: {
    price: 1480000, express_fee: 45000,
    lease_12: { down: 680000, monthly: 89200 },
    lease_24: { down: 680000, monthly: 54600 },
    lease_36: { down: 680000, monthly: 46400 },
  },
};

export function expandPricing(input) {
  const express_fee = {}, price_table = {};
  for (const [key, m] of Object.entries(input)) {
    express_fee[key] = m.express_fee;
    const table = { cash: { total: m.price, months: 0 } };
    for (const [leaseKey, months] of Object.entries(LEASE_MONTHS)) {
      const { down, monthly } = m[leaseKey];
      table[leaseKey] = { down, monthly, months, total: down + monthly * months };
    }
    price_table[key] = table;
  }
  return { express_fee, price_table, input };
}

export const DEFAULT_PRICING = expandPricing(DEFAULT_PRICING_INPUT);

export const fmt = (n) => new Intl.NumberFormat("hu-HU").format(Math.round(n)) + " Ft";

export function calculate(machine, quantity, delivery, payment, pricing = DEFAULT_PRICING) {
  const entry = pricing.price_table[machine][payment];
  const deliveryFee = delivery === "d48" ? pricing.express_fee[machine] * quantity : 0;
  const baseTotal = entry.total * quantity;
  const total = baseTotal + deliveryFee;
  const months = entry.months || 0;
  const monthly = (entry.monthly || 0) * quantity;
  const downPayment = months ? (entry.down || 0) * quantity + deliveryFee : 0;
  return { baseTotal, deliveryFee, total, months, monthly, downPayment };
}
